<img class="rotate"
     data-testid="loader-icon"
     [class.dark]="dark()"
     ngSrc="/assets/img/icons/loading.svg"
     [height]="size()" [width]="size()"
     priority="true"
     alt="" />
